/**
 * Registers the same handler for both `click` and `auxclick` (middle-click)
 * on the given element. Pass `{ signal }` from an AbortController to remove
 * both listeners at once via `abortController.abort()`.
 */
export function onClickOrAuxclick(
  el: Element,
  handler: (e: MouseEvent) => void,
  options: AddEventListenerOptions,
): void {
  el.addEventListener("click", handler as EventListener, options);
  el.addEventListener("auxclick", handler as EventListener, options);
}
